export default __webpack_public_path__ + "static/media/logo-finanzas.0ed886c1.png";